export const containsHebrew = (text: string): boolean => {
  const position = text.search(/[\u0590-\u05FF]/)
  return position >= 0
}
